<script>
  import { onDestroy, createEventDispatcher } from "svelte";
  import * as PropTypes from "prop-types";
  import Loader from "@/components/atoms/Loader.svelte";
  import { onMount } from "svelte";
  export let threshold = 0;
  export let horizontal = false;
  export let elementScroll;
  export let elementOffset;
  export let hasMore = true;
  export let loading = false;
  export let isDarkTheme = false;
  export let dataTestIdLoader = "";
  const { checkPropTypes, number, bool, object, string } = PropTypes;
  const propTypes = {
    threshold: number,
    horizontal: bool,
    elementScroll: object,
    elementOffset: object,
    hasMore: bool,
    loading: bool,
    isDarkTheme: bool,
    dataTestIdLoader: string,
  };
  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "InfinteScroll");
  });

  const dispatch = createEventDispatcher();
  let isLoadMore = false;
  let component;

  $: {
    if (component || elementScroll) {
      const element = elementScroll || component.parentNode;
      element.addEventListener("scroll", onScroll);
      element.addEventListener("resize", onScroll);
    }
  }

  const onScroll = (e) => {
    const element = elementOffset || e.target;

    const offset = horizontal
      ? element.scrollWidth - element.clientWidth - element.scrollLeft
      : element.scrollHeight - element.clientHeight - element.scrollTop;

    if (offset <= threshold) {
      if (!isLoadMore && hasMore) {
        dispatch("loadMore");
      }
      isLoadMore = true;
    } else {
      isLoadMore = false;
    }
  };

  onDestroy(() => {
    if (component || elementScroll) {
      const element = elementScroll || component.parentNode;
      element.removeEventListener("scroll", onScroll);
      element.removeEventListener("resize", onScroll);
    }
  });
</script>

<div bind:this={component} style="width:0px" />
{#if loading}
  <div data-testid={dataTestIdLoader} class="flex items-center justify-center mt-xl">
    <Loader color={isDarkTheme ? "#fff" : "#577EFB"} size={"32px"} />
  </div>
{/if}
